import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { Button, Modal, Row, Col, Form, OverlayTrigger } from "react-bootstrap";
import { MdFilterList, MdAddCircle, MdEdit, MdDelete, MdRemoveRedEye } from "react-icons/md";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from 'react-toastify';
import { Tooltip } from '@mui/material';
import loading from "../../assets/images/common/loading.gif";
import AppDataGrid from '../../components/common/AppDataGrid';


const LeaveApproval = () => {
    const [showFilterModal, setShowFilterModal] = useState(false);
    const handleCloseFilterModal = () => setShowFilterModal(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [filter, setFilter] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const userData = sessionStorage.getItem('user');
    const [leaves, setleaves] = useState([]);
    const userObj = userData ? JSON.parse(userData) : {};
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate();
    const [showViewForm, setViewForm] = useState(false);
    const handleClosePopupModal = () => setViewForm(false);
    const [users, setUsers] = useState([]);
    const [showReasonModal, setShowReasonModal] = useState(false);
    const [selectedReason, setSelectedReason] = useState("");

    const [form, setForm] = useState({
        leave_entry_id: "",
        userid: "",
        leave_id: "",
        apply_date: "",
        from_date: "",
        to_date: "",
        reason: "",
        approved_by: "",
        approved_date: "",
        status: "",
        school_id: "",
        user_name: "",
        leave_description: "",
        approved_by_name: "",
        school_name: "",
        total_days: "",
        rejected_reason: "",

    })

    const fetchleaves = async () => {
        try {
            const response = await axios.post(baseUrl + "/LeaveEntryRead/", {
                action: "READ",
                school_id: userObj.school_id,
            });
            setleaves(response.data || []);
        } catch (error) {
            console.error("Error fetching leaves:", error);
        }
    };

    const fetchDropdownData = async (endpoint, setter) => {
        try {
            const response = await axios.post(baseUrl + endpoint, { action: 'READ', school_id: userObj.school_id });
            setter(response.data);
        } catch (error) {
            console.error(`Error fetching ${endpoint}:`, error);
        }
    };

    const handleShowFilterModal = () => {
        if (users.length === 0) {
            fetchDropdownData('/Users/', setUsers, userObj.school_id);
        }

        setShowFilterModal(true);
    }

    const formatDate1 = (datetime) => {
        if (!datetime) return "";
        const date = new Date(datetime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };



    useEffect(() => {
        setIsLoading(true);
        fetchleaves().finally(() => setIsLoading(false));

    }, []);


    const handleViewClick = (leave_entry_id) => {
        const leaveToView = leaves.find(leave => leave.leave_entry_id === leave_entry_id);
        if (leaveToView) {
            setForm(leaveToView);
            setViewForm(true);
        } else {
            console.error(`ID ${leave_entry_id} not found`);
        }
    };

    const handleLeaveApproval = async (status) => {
        try {
            if (status === "Rejected" && (!form.rejected_reason || form.rejected_reason.trim() === "")) {
                toast.error("Rejected reason is required when rejecting leave");
                return;
            }
            setViewForm(false);

            setIsLoading(true);

            let statusCode = "";
            if (status === "Approved") statusCode = "A";
            if (status === "Rejected") statusCode = "R";
            if (status === "Cancel") statusCode = "C";

            const payload = {
                action: "UPDATE",
                leave_entry_id: form.leave_entry_id,
                approved_by: userObj.user_id,
                status: statusCode,
                rejected_reason: form.rejected_reason
            };

            const response = await axios.post(baseUrl + "/leave-approval/", payload);

            if (response.data && response.data.message === "Success") {
                toast.success(`Leave ${status.toLowerCase()} successfully!`);
                setViewForm(false);
                fetchleaves();
            } else {
                toast.error("Failed to update leave status");
            }
        } catch (error) {
            console.error("Error approving/rejecting leave:", error);
            toast.error("Error processing leave approval");
        } finally {
            setIsLoading(false);
        }
    };

    const handleReset = async (e) => {
        e.preventDefault();
        setFilter({
            from_date: "",
            to_date: "",
            userid: null,
            status: "",
            action: "FILTER"

        });
        setShowFilterModal(true);
        fetchleaves();
    };


    const columns = [
  {
    field: "user_name",
    headerName: "Employee Name",
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span>{params.value}</span>
      </Tooltip>
    ),
    sortable: true,
  },
  {
    field: "leave_description",
    headerName: "Leave Type",
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span>{params.value}</span>
      </Tooltip>
    ),
    sortable: true,
  },
  {
    field: "apply_date",
    headerName: "Apply Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <Tooltip title={formatDate1(params.value)}>
        <span>{formatDate1(params.value)}</span>
      </Tooltip>
    ),
    sortable: true,
  },
  {
    field: "from_date",
    headerName: "From Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <Tooltip title={formatDate1(params.value)}>
        <span>{formatDate1(params.value)}</span>
      </Tooltip>
    ),
    sortable: true,
  },
  {
    field: "to_date",
    headerName: "To Date",
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) =>
      params.row.isNoRecords ? (
        <span style={{ color: "red" }}>No Records Found</span>
      ) : (
        <Tooltip title={formatDate1(params.value)}>
          <span>{formatDate1(params.value)}</span>
        </Tooltip>
      ),
    sortable: true,
  },
  {
    field: "total_days",
    headerName: "Total Days",
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span>{params.value}</span>
      </Tooltip>
    ),
    sortable: true,
  },
  {
    field: "reason",
    headerName: "Reason",
    flex: 1.2,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <div
        style={{ cursor: "pointer" }}
        onClick={() => {
          setSelectedReason(params.value || "No reason provided");
          setShowReasonModal(true);
        }}
      >
        {(params.value || "").length > 15
          ? `${params.value.substring(0, 15)}...`
          : params.value}
      </div>
    ),
    sortable: true,
  },
{
  field: "status",
  headerName: "Status",
  flex: 1,
  headerAlign: "center",
  align: "center",
  renderCell: (params) => {
    const status = params.value?.toLowerCase();
    let color = "";
 
    switch (status) {
      case "approved":
      case "a":
        color = "green";
        break;
      case "rejected":
      case "r":
        color = "red";
        break;
      case "cancelled":
      case "cancel":
      case "c":
        color = "orange";
        break;
      case "pending":
      case "p":
        color = "#007bff"; // blue for pending
        break;
      default:
        color = "#333"; // default text color
    }
 
    return (
      <Tooltip title={params.value}>
        <span style={{ color, fontWeight: "600", textTransform: "capitalize" }}>
          {params.value}
        </span>
      </Tooltip>
    );
  },
  sortable: true,
}
 
,
  {
    field: "actions",
    headerName: "Actions",
    flex: 1,
    headerAlign: "center",
    align: "center",
    renderCell: (params) =>
      params.row.isNoRecords ? null : (
        <div className="tableActions">
          {params.row.status === "Pending" ? (
            <Tooltip title="Edit" arrow>
              <span
                className="commonActionIcons"
                onClick={() => handleViewClick(params.row.leave_entry_id)}
              >
                <MdEdit />
              </span>
            </Tooltip>
          ) : (
            <Tooltip title="View" arrow>
              <span
                className="commonActionIcons"
                onClick={() => handleViewClick(params.row.leave_entry_id)}
              >
                <MdRemoveRedEye />
              </span>
            </Tooltip>
          )}
        </div>
      ),
  },
];



    const handleInputChange = (e) => {
        const { id, value } = e.target;
        if (/^[A-Za-z\s]*$/.test(value)) {
            setFilter((prev) => ({
                ...prev,
                [id]: value,
            }));
        }
    };
    const handleFilterSubmit = async () => {
        try {
            const response = await axios.post(baseUrl + "/LeaveEntryRead/", {
                action: "FILTER",
                school_id: userObj.school_id,
                from_date: filter.from_date || "",
                to_date: filter.to_date || "",
                userid: filter.userid,
                status: filter.status

            });

            setleaves(response.data || []);
            handleCloseFilterModal();
        } catch (error) {

            setleaves([]);
            handleCloseFilterModal();

        }
    };


    const searchableColumns = [
        (row) => row.user_name,
        (row) => row.leave_description,
        (row) => formatDate1(row.from_date),
        (row) => formatDate1(row.to_date),
        (row) => formatDate1(row.apply_date),
        (row) => row.total_days,
        (row) => row.status,
        (row) => row.reason

    ];

    const filteredRecords = (leaves || []).filter((item) =>
        searchableColumns.some((selector) => {
            const value = selector(item);
            const stringValue = String(value || '').toUpperCase().replace(/[-\s]+/g, '');
            const normalizedQuery = searchQuery.toUpperCase().replace(/[-\s]+/g, '');
            return stringValue.includes(normalizedQuery);
        })
    );

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };


    return (

        <div className="pageBody">
            <ToastContainer />

            <div className="commonDataTableHead">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <h6 className="commonTableTitle">Leave Approval</h6>
                    </div>
                    <div className="">
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            className="searchInput"
                            maxLength={15}
                            onChange={handleSearchChange}
                        />
                    </div>

                    <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}>
                            <Button className="secondaryBtn" variant="secondary" onClick={handleShowFilterModal}>
                                <MdFilterList />
                            </Button>
                        </OverlayTrigger>

                    </div>
                </div>
            </div>

            <div className="commonTable height100">
                <div className="tableBody">
                    {isLoading ? (
                        <div className="loadingContainer">
                            <img src={loading} alt="Loading..." className="loadingGif" />
                        </div>
                    ) : (
                        <AppDataGrid
                            rows={filteredRecords.length ? filteredRecords : []}
                            columns={columns}
                            getRowId={(row) => row.leave_entry_id}
                            pageSizeOptions={[10, 20, 50]}      // Dropdown options
                            showToolbar={false}
                            pagination
                            density="compact"
                            maxHeight={550}
                        />
                    )}
                </div>
            </div>
            <Modal show={showViewForm} onHide={() => setViewForm(false)} centered size="md" dialogClassName="custom-modal">
                <Modal.Header closeButton>
                    <div className="d-flex justify-content-between w-100">
                        <Modal.Title>Leave Approval</Modal.Title>
                        <span style={{ marginRight: "40px", marginTop: "9px" }}>
                            <strong>Status:</strong> {form.status}
                        </span>
                    </div>
                </Modal.Header>




                <Modal.Body style={{ minHeight: "380px", maxHeight: "75vh", overflowY: "auto" }}>
                    <Form id="ModalForm">
                        <Row className="px-3 pt-2 g-3">
                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "160px" }}>Employee Name:</strong>
                                <span>{form.user_name}</span>
                            </Col>

                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "160px" }}>Leave Type:</strong>
                                <span>{form.leave_description}</span>
                            </Col>



                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "160px" }}>From Date:</strong>
                                <span>{formatDate1(form.from_date)}</span>
                            </Col>


                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "160px" }}>To Date:</strong>
                                <span>{formatDate1(form.to_date)}</span>
                            </Col>

                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "160px" }}>Apply Date:</strong>
                                <span>{formatDate1(form.apply_date)}</span>
                            </Col>
                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "160px" }}>Total Days:</strong>
                                <span>{form.total_days}</span>
                            </Col>

                            <Col md={6} className="mb-2 d-flex align-items-start">
                                <strong style={{ width: "160px" }}>Reason:</strong>
                                <span
                                    style={{
                                        display: "inline-block",
                                        whiteSpace: "pre-wrap",
                                        wordWrap: "break-word",
                                        maxWidth: "calc(100% - 160px)",
                                        maxHeight: "80px",
                                        //   overflowY: "auto",
                                    }}
                                >
                                    {form.reason || "No reason provided"}
                                </span>
                            </Col>


                            {/* <Col md={6} className="mb-2 d-flex align-items-center">
                                                    <strong style={{ width: "140px" }}>Status:</strong>
                                                    <span>{form.status}</span>
                                                </Col> */}
                            <Col md={6} className="mb-2 d-flex align-items-start">
                                <strong style={{ width: "160px" }}>Remarks:</strong>
                                {(form.status === "Pending" || form.status === "P") ? (
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        maxLength={100}
                                        value={form.rejected_reason || ""}
                                        onChange={(e) =>
                                            setForm({ ...form, rejected_reason: e.target.value })
                                        }
                                        style={{
                                            width: "100%",
                                            minWidth: "300px",
                                            height: "70px",
                                        }}
                                    />
                                ) : (
                                    <span
                                        style={{
                                            display: "inline-block",
                                            whiteSpace: "pre-wrap",
                                            wordWrap: "break-word",
                                            maxWidth: "calc(100% - 160px)"
                                        }}
                                    >
                                        {form.rejected_reason}
                                    </span>
                                )}
                            </Col>


                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="d-flex w-100">
                    <Button
                        variant="secondary"
                        onClick={() => setViewForm(false)}
                    >
                        Close
                    </Button>

                    {(form.status === "Pending" || form.status === "P") && (
                        <div className="ms-auto">
                            <Button
                                variant="success"
                                onClick={() => handleLeaveApproval("Approved")}
                            >
                                Approve
                            </Button>
                            <Button
                                variant="danger"
                                className="ms-2"
                                onClick={() => handleLeaveApproval("Rejected")}
                            >
                                Reject
                            </Button>
                        </div>
                    )}
                </Modal.Footer>


            </Modal>


            <Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
                <Modal.Header closeButton className="modalHeaderFixed">
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBodyScrollable">
                    <Row>

                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="month_name">
                                    <Form.Label>Employee Name</Form.Label>                                                                                                                                        <Form.Select
                                        name="userid"
                                        id="userid"
                                        value={filter.userid || ""}
                                        onChange={(e) => setFilter({ ...filter, userid: e.target.value })}
                                    >
                                        <option value="" disabled hidden>Select Employee Name</option>
                                        {(users || []).map((user) => (
                                            <option key={user.userid} value={user.userid}>
                                                {`${user.surname || ''} ${user.firstname || ''}`.trim()}
                                            </option>
                                        ))}
                                    </Form.Select>

                                </Form.Group>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="from_date">
                                    <Form.Label>From Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        id="from_date"
                                        value={filter.from_date || ""}
                                        onChange={(e) => {
                                            const value = e.target.value;


                                            if (filter.to_date && value > filter.to_date) {
                                                alert("From Date cannot be later than To Date");
                                                return;
                                            }

                                            setFilter((prev) => ({
                                                ...prev,
                                                from_date: value,
                                            }));
                                        }}
                                    />
                                </Form.Group>
                            </div>
                        </Col>

                        <div className='commonInput'>
                            <Form.Group controlId="to_date">
                                <Form.Label>To Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    id="to_date"
                                    value={filter.to_date || ""}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        if (filter.from_date && value < filter.from_date) {
                                            alert("To Date cannot be earlier than From Date");
                                            return;
                                        }
                                        setFilter((prev) => ({
                                            ...prev,
                                            to_date: value,
                                        }));
                                    }}
                                />
                            </Form.Group>
                        </div>

                        <Col xs={12}>
                            <div className='commonInput'>
                                <Form.Group controlId="status">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select
                                        name="status"
                                        id="status"
                                        value={filter.status || ""}
                                        onChange={(e) => setFilter({ ...filter, status: e.target.value })}
                                    >
                                        <option value="" disabled hidden>Select Status</option>
                                        <option value="A">Approved</option>
                                        <option value="R">Rejected</option>
                                        <option value="P">Pending</option>
                                        <option value="C">Cancelled</option>
                                    </Form.Select>
                                </Form.Group>
                            </div>
                        </Col>

                    </Row>
                </Modal.Body>
                <Modal.Footer className="modalFooterFixed">
                    <Button variant="secondary" className="btn-info clearBtn me-2" onClick={handleReset}>
                        Reset
                    </Button>
                    <div>
                        <Button variant="secondary" className="btn-danger secondaryBtn me-2" onClick={() => { handleCloseFilterModal(); }}>
                            Cancel
                        </Button>
                        <Button variant="primary" className="btn-success primaryBtn" onClick={handleFilterSubmit}>
                            Search
                        </Button></div>
                </Modal.Footer>

            </Modal>
            <Modal
                show={showReasonModal}
                onHide={() => setShowReasonModal(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Reason</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                    <p>{selectedReason}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowReasonModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );

};
export default LeaveApproval;